<template>
  <div>
    <vue-header title="面诊" isReturn="true"/>
    <camera  :type="type"/>
  </div>
</template>
<script>
  import vueHeader from "@/components/header";
  import camera from "@/components/camera";
  export default {
    name: "step1",
    components: {
      vueHeader,
      camera
    },
    data(){
      return{
          type:1    //普通面诊
      }
    },
    created:function(){
        let flow = sessionStorage.getItem('flow');
        if(flow){
          let flow_step = JSON.parse(flow).flow_info.flow_step;
          if(flow_step==18||flow_step==19||flow_step==20){  //深度面诊
            this.type = 6;
          }
        }
    },
  };
</script>